import { render, staticRenderFns } from "./SocialMediaClue.vue?vue&type=template&id=63e78230&scoped=true&"
import script from "./SocialMediaClue.vue?vue&type=script&lang=js&"
export * from "./SocialMediaClue.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaClue.vue?vue&type=style&index=0&id=63e78230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e78230",
  null
  
)

export default component.exports